import React, { Component, Fragment } from 'react';
import i18n from '../../../plugins/i18n/i18n'
import { actions } from '../../../store/modules';
import { connect } from 'react-redux';
import { Input, Form, Button, Spin, Select, Row, Col, Checkbox, Tooltip, Result, notification as Notification } from 'antd';
import { errorMessageNotification } from '../../../helpers/index'
import queryString from "query-string";
import PhoneInput from 'react-phone-number-input'
import cookie from "js-cookie";

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadings: {
        first: false
      },
      isSuccess: false,
      check: null,
      email: null,
      emailDomain: null,
      customerId: null,
      values: {
        customers: []
      }
    }
  }
  componentDidMount() {

    let params = queryString.parse(window.location.search);
    if (params.email) {

      const domain = params.email.split('@')

      this.setState({ email: params.email, emailDomain: domain[1] })
      this.getCustomers(domain[1])

    } else {
      this.props.history.push(
        `/auth/sign-in`
      )
    }
  }

  getCustomers = (domain) => {

    let endpoint = { keyOne: `customergroup/customers/${domain}` };
    let { values } = this.state;
    this.props
      .dispatch(
        actions.definitions.getDatas({
          ...endpoint
        })
      )
      .then(response => {
        values.customers = response
        this.setState({
          values,
        });
      });
  };

  fetchRegister = (values) => {

    let endpoint = { keyOne: `account/register` };


    this.setState({ loading: true })

    this.props.dispatch(
      actions.definitions.addData({
        ...endpoint,
        data: values
      })
    )
      .then((response) => {
        this.setState({ check: response })

        this.setState(
          {
            isSuccess: true,
            loading: false

          },
          () => {
            // setTimeout(() => {
            //   _this.setState({ loginSuccess: null });
            // }, 3500);
          })

      }
      )
      .catch(error => {
        this.setState(
          {
            loading: false

          },
          () => {
            Notification.error({
              message: i18n.t(`error`, {
                lng: this.props.currentLanguage,
              }),
              description: errorMessageNotification(error),
              className: "general-notification",
              placement: "bottomLeft",
              duration: 100,
            });
          })
      })
  }

  onSelectCustomer = (value) => {
    this.setState({ customerId: value })
  }

  getTooltipText = () => {

    var text = "Şifreniz şunları içermelidir, \n";
    text += "- En az 8 karakter \n";
    text += "- Büyük ve küçük harfler \n";
    text += "- En az 1 rakam";

    return text;

  }

  render() {

    let { loading, loadings, values, email, customerId, isSuccess } = this.state;

    const integrationEmail = cookie.get("araciste.integration.user.email");


    return (
      <div className="auth-content">

        {
          loadings.first &&
          <div className="ant-loading loading-content">
            <Spin
              tip={`${i18n.t(`loading`, {
                lng: this.props.currentLanguage,
              })}`}
            />
          </div>
        }

        {
          !isSuccess &&
          <h1 className="heading">
            Bu e-posta adresi ile hemen üye olabilirsiniz!
          </h1>

        }
        {
          email && !isSuccess &&
          <div className='form-box'>

            <Form
              layout="vertical"
              onFinish={this.fetchRegister}>

              <Form.Item
                label="E-posta Adresi"
                name="email"
                rules={[
                  {
                    type: "email",
                    message: i18n.t("emailInvalid")
                  },
                  {
                    required: true,
                    message: `${i18n.t("fieldIsRequired", {
                      lng: this.props.currentLanguage,
                    })}`,
                  }
                ]}
                initialValue={email}

              >
                <Input
                  type="email"
                  placeholder="e-posta@alanadi.com"
                  disabled
                />
              </Form.Item>

              <Form.Item
                label={`Çalıştığınız şirketi seçin`}
                name="customerId"
                rules={[
                  {
                    required: true,
                    message: `${i18n.t("fieldIsRequired", {
                      lng: this.props.currentLanguage,
                    })}`,
                  },
                ]}
              >
                <Select
                  placeholder={`${i18n.t("customer", {
                    lng: this.props.currentLanguage,
                  })}`}
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onSelect={(value) => this.onSelectCustomer(value)}
                >
                  {values.customers.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}

                </Select>
              </Form.Item>

              {
                customerId &&

                <Fragment>

                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Form.Item
                        label="Ad"
                        name="name"
                        rules={[
                          {
                            required: true,
                            message: `${i18n.t("fieldIsRequired", {
                              lng: this.props.currentLanguage,
                            })}`,
                          }
                        ]}
                      >
                        <Input
                          placeholder="Adınızı yazınız"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Form.Item
                        label="Soyad"
                        name="lastname"
                        rules={[
                          {
                            required: true,
                            message: `${i18n.t("fieldIsRequired", {
                              lng: this.props.currentLanguage,
                            })}`,
                          }
                        ]}
                      >
                        <Input
                          placeholder="Soyadınızı yazınız"
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Form.Item
                        label="Cep Telefonu"
                        name="phoneNumber"
                        rules={[
                          {
                            required: true,
                            message: `${i18n.t("fieldIsRequired", {
                              lng: this.props.currentLanguage,
                            })}`,
                          }
                        ]}
                      >
                        {/* <Input
                          placeholder="Adınızı yazınız"
                        /> */}
                        <PhoneInput
                          country="TR"
                          placeholder="+90 555 555 55 55"
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  {
                    !integrationEmail &&
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Tooltip placement="topLeft" title={this.getTooltipText()} trigger="focus" overlayStyle={{ whiteSpace: 'pre-line' }}>

                          <Form.Item
                            label="Şifre"
                            name="password"
                            rules={[
                              {
                                required: true,
                                message: `${i18n.t("fieldIsRequired", {
                                  lng: this.props.currentLanguage,
                                })}`,
                              }
                            ]}
                          >
                            <Input.Password
                              placeholder="Şifrenizi yazınız"
                            />
                          </Form.Item>
                        </Tooltip>
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Tooltip placement="topLeft" title={this.getTooltipText()} trigger="focus" overlayStyle={{ whiteSpace: 'pre-line' }}>

                          <Form.Item
                            label="Şifre Tekrar"
                            name="confirmPassword"
                            rules={[
                              {
                                required: true,
                                message: `${i18n.t("fieldIsRequired", {
                                  lng: this.props.currentLanguage,
                                })}`,
                              }
                            ]}
                          >
                            <Input.Password
                              type='password'
                              placeholder="Şifrenizi tekrar yazınız"
                            />
                          </Form.Item>
                        </Tooltip>
                      </Col>
                    </Row>
                  }
                  <Row>
                    <Col span={24}>
                      <Form.Item
                        name="userAgreement"
                        valuePropName="checked"
                        rules={[
                          {
                            required: true,
                            message: `${i18n.t("fieldIsRequired", {
                              lng: this.props.currentLanguage,
                            })}`,
                          }
                        ]}
                      >
                        <Checkbox><a href='https://araciste.koczer.com/agreement/membership' target='_blank' rel='noopener noreferrer'>Üyelik Sözleşmesi,</a>  okudum kabul ediyorum.</Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <Form.Item
                        name="isProtectionOfPersonelData"
                        valuePropName="checked"
                        rules={[
                          {
                            required: true,
                            message: `${i18n.t("fieldIsRequired", {
                              lng: this.props.currentLanguage,
                            })}`,
                          }
                        ]}
                      >
                        <Checkbox><a href='https://araciste.koczer.com/agreement/privacy' target='_blank' rel='noopener noreferrer'>Araçiste GİZLİLİK POLİTİKASI </a>’nda belirtilen şekliyle kişisel verilerimin doğrudan veya dolaylı pazarlama faaliyetlerinin gerçekleştirilmesi amacıyla işlenmesini ve yukarıda belirtilen iletişim bilgilerime reklam, promosyon, vb. ticari elektronik ileti gönderilmesini, bilgilerimin bu amaçla kullanılmasını, saklanmasını ve ZER’in hizmet aldığı üçüncü kişilerle paylaşılmasını kabul ediyorum.</Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>

                </Fragment>



              }
              <Form.Item>
                <Button
                  className="width-100"
                  htmlType="submit"
                  type="primary"
                  loading={loading}
                  style={{ marginBottom: 50 }}
                >
                  {
                    i18n.t('continue', { lng: this.props.currentLanguage })
                  }

                </Button>
              </Form.Item>
            </Form>

          </div>

        }

        {
          isSuccess &&
          <div className='form-box'>

            <Result
              status="success"
              title="ÜYELİK İŞLEMİ GERÇEKLEŞTİ"
              subTitle="Hesabınızı doğrulamak için e-posta adresinizi kontrol ediniz."
              extra={[
                <Button key="buy"
                  onClick={() => this.props.history.push(
                    `/auth/send-email-confirmation?email=${email}`
                  )}

                >Doğrulama E-postasını Tekrar Gönder</Button>,
              ]}
            />
          </div>
        }
      </div>
    )
  }
}


const mapStateToProps = ({ auth }) => ({
  ...auth
});
export default connect(mapStateToProps)(Register);





// WEBPACK FOOTER //
// ./src/components/Auth/Views/Register.js